"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useFieldMappings(query) {
  const { ...rest } = useElements("field-mappings", query);
  return {
    fieldMappings: rest.items,
    ...rest
  };
}

export { useFieldMappings };
